import styled from 'styled-components';

export const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flexgrow: 1;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;
